import WorkReportsPageLayout from 'container/WorkReportsPageLayout'
import React from 'react'

const WorkReports: React.FC = () => <WorkReportsPageLayout />

export default WorkReports
